import { useQuery } from '@tanstack/react-query';
import { authFetch } from '../utils/authFetch';
import { API_URL } from '../config/api';
import { DisbursementRule } from '../types';

export function useListDisbursementRules() {
  return useQuery<DisbursementRule[]>({
    queryKey: ['disbursementRules'],
    queryFn: async () => {
      const response = await authFetch(`${API_URL}/disbursement-rules/`);
      return response.json();
    },
  });
} 